import { PropertyTypes } from "@eave/shared/types/api";

// Taken from "EAVE PROPERTY TYPES" table in:
// https://paper.dropbox.com/doc/Appraisal-Ingestion--AlcmJzRSMsn30pXLvC3RONQKAg-opcTxYKsLoxEHxnByKGaP#:h2=EAVE-PROPERTY-TYPES
export enum PropertyTypeUnits {
  SFR = "1",
  SFRATT = "1",
  PUD = "1",
  PUDATT = "1",
  SiteCondo = "1",
  LowRiseCondo = "1",
  MidRiseCondo = "1",
  HighRiseCondo = "1",
  Duplex = "2",
  DuplexATT = "2",
  Triplex = "3",
  TriplexATT = "3",
  Quadplex = "4",
  QuadplexATT = "4",
}

export function getPropertyTypeUnits(propertyType: string) {
  const key = Object.keys(PropertyTypes).find(type => PropertyTypes[type] === propertyType);
  if (key) {
    return PropertyTypeUnits[key];
  }
  throw new Error("Unsupported Property Type");
}
